module.exports = __webpack_public_path__ + "static/media/logout.d73f31d8.svg";